module.exports = __webpack_public_path__ + "img/claim-fail.dfdd6a04.png";